export default [{
  path: '/log-unitizacao',
  component: () => import('@/views/Index'),
  children: [
    {
      name: 'Log de Unitização Histórico',
      path: 'historico',
      component: () => import('@/views/logUnitizacao/Historico.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'Log de Unitização' }
        ]
      }
    },
    {
      name: 'Log de Unitização Pesquisa',
      path: 'pesquisa',
      component: () => import('@/views/logUnitizacao/Pesquisa.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'Log de Unitização', path: '/log-unitizacao/historico' },
          { name: 'Pesquisa' }
        ]
      }
    },
    {
      name: 'Log de Unitização Upload',
      path: 'upload',
      component: () => import('@/views/logUnitizacao/Upload.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'Log de Unitização', path: '/log-unitizacao/historico' },
          { name: 'Unitização' }
        ]
      }
    },
    {
      name: 'Log de Unitização Adicionar',
      path: 'edit',
      redirect: '/log-unitizacao/pesquisa'
    }
  ]
}];
